import { render, staticRenderFns } from "./InputGenerator.vue?vue&type=template&id=2bc1ca24"
import script from "./InputGenerator.vue?vue&type=script&lang=js"
export * from "./InputGenerator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports